const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Storage {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'storageExt', name: '💾 保存', color1: '#FF8C1A', color2: '#DB6E00',
            blocks: [
                { opcode: 'set', blockType: BlockType.COMMAND, text: '[K] に [V] を保存', arguments: { K: { type: ArgumentType.STRING, defaultValue: 'score' }, V: { type: ArgumentType.STRING, defaultValue: '100' } } },
                { opcode: 'get', blockType: BlockType.REPORTER, text: '[K] の値', arguments: { K: { type: ArgumentType.STRING, defaultValue: 'score' } } },
                { opcode: 'remove', blockType: BlockType.COMMAND, text: '[K] を削除', arguments: { K: { type: ArgumentType.STRING, defaultValue: 'score' } } },
                { opcode: 'clear', blockType: BlockType.COMMAND, text: 'すべて削除' },
                { opcode: 'has', blockType: BlockType.BOOLEAN, text: '[K] は保存されている？', arguments: { K: { type: ArgumentType.STRING, defaultValue: 'score' } } },
                { opcode: 'keys', blockType: BlockType.REPORTER, text: 'すべてのキー' }
            ]
        };
    }
    _p() { return 'sm_'; }
    set(args) { try { localStorage.setItem(this._p() + args.K, Cast.toString(args.V)); } catch(e) {} }
    get(args) { try { return localStorage.getItem(this._p() + args.K) || ''; } catch(e) { return ''; } }
    remove(args) { try { localStorage.removeItem(this._p() + args.K); } catch(e) {} }
    clear() { try { var p = this._p(); Object.keys(localStorage).filter(function(k) { return k.startsWith(p); }).forEach(function(k) { localStorage.removeItem(k); }); } catch(e) {} }
    has(args) { try { return localStorage.getItem(this._p() + args.K) !== null; } catch(e) { return false; } }
    keys() { try { var p = this._p(); return Object.keys(localStorage).filter(function(k) { return k.startsWith(p); }).map(function(k) { return k.slice(p.length); }).join(','); } catch(e) { return ''; } }
}
module.exports = Scratch3Storage;